
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Origen de datos',
	'dataSourceId': 'ID',
	'dataSourceType': 'Tipo',
	'dataSourceName': 'Nombre',
	'dataSourcePath': 'Ruta',
	'showInfoForAll': 'Mostrar duración para todas las visualizaciones',
	'hideInfoForAll': 'Ocultar duración para todas las visualizaciones',
	'showPerformanceDetails': 'Volver a ejecutar todos los widgets para incluir detalles de rendimiento',
	'slotMappingField': 'Correlaciones de ranura',
	'slotDataMapping': 'Correlación',
	'slotID': 'ID',
	'slotCaption': 'Título',
	'slotMandatory': 'Obligatorio',
	'slotIsMandatory': 'Sí',
	'slotIsNotMandatory': 'No',
	'infoNotAvailable': 'No disponible',
	'performanceSection': 'Rendimiento',
	'durationField': 'Duración',
	'singleQueryTime': 'Consulta de servidor (ms)',
	'multipleQueryTime': 'Consulta de servidor %{name} (ms)',
	'liveWidgetTotalTime': 'Total (ms)',
	'renderTimeNotAvailable': 'No disponible',
	'renderInProgress': '(en curso)',
	'interactToTriggerQuery': 'Interactuar con el widget para desencadenar una consulta',
	'fetchQuery': 'Consulta de captura',
	'showSQLMDX': 'Mostrar SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Información sobre consultas',
	'queryInfoNotAvailable': 'La información de consulta no está disponible',
	'query': 'Consulta',
	'copy': 'Copiar',
	'close': 'Cerrar'
});
